import type { UseQueryOptions, UseQueryResult } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';

/**
 * ErrorBoundary와 연동되는 useQuery 래퍼
 * 에러 발생 시 자동으로 throw하여 상위 ErrorBoundary가 처리하도록 함
 */
export const useQueryWithBoundary = <
  TQueryFnData = unknown,
  TError = Error,
  TData = TQueryFnData,
  TQueryKey extends readonly unknown[] = readonly unknown[],
>(
  options: UseQueryOptions<TQueryFnData, TError, TData, TQueryKey>
): UseQueryResult<TData, TError> => {
  const result = useQuery(options);

  if (result.error) {
    throw result.error;
  }

  return result;
};
